import {
  Stack,
  IconButton,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import { ExpandMore, Replay } from "@mui/icons-material";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";

import { formatDateISO8601 } from "../../../../utils/formatarData";
import { ReactComponent as IconDiamond } from "../../../../images/icon-diamond.svg";
import { ReactComponent as IconNote } from "../../../../images/iconNote.svg";

import AccordionSummaryTitle from "../AccordionSummaryTitle";
import {
  FieldSelect,
  FieldDatePicker,
  FieldAutocomplete,
  FieldInputText,
} from "../../../../components/Fields";

import "../styles.css";

const handleProgressForm = (data) => {
  const fieldHide = "*";
  const isAux =
    data.diagnosticoEhELA === "50" || data.diagnosticoEhELA === "119";
  const fields = [
    data.diagnosticoEhELA,
    data.diagnosticoEhELA === "51" ? data.sugestaoDiagnostico : fieldHide,
    isAux ? data.dataDiagnosticoELA : fieldHide,
    isAux ? data.classificacaoKingsCollege : fieldHide,
    isAux ? data.escalaFuncional : fieldHide,
    isAux ? data.velocidadeDeProgressao : fieldHide,
    isAux ? data.causaELA : fieldHide,
    isAux ? data.localDeInicio : fieldHide,
    isAux ? data.fenotipoDeInicio : fieldHide,
    data.diagnosticoEhELA !== "" ? data.observacaoELA : fieldHide,
  ];

  if (fields.every((campo) => campo !== "")) {
    return "full";
  } else if (fields.some((campo) => campo !== "" && campo !== fieldHide)) {
    return "partial";
  } else {
    return "empty";
  }
};

export default function DiagnosticoEla({
  expanded,
  handleChangePanel,
  onSubmit,
  data,
  setData,
  diagnosticoEhELAOptions,
  CIDList,
  classificacaoKingsCollegeOptions,
  atualizarEscalaFuncional,
  escalaFuncional,
  causaOptions,
  localDeInicioOptions,
  fenotipoDeInicioOptions,
  idConsultaEvolucao,
}) {
  function handleSetData(value, field) {
    setData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }

  const progressForm = handleProgressForm(data);
  return (
    <Accordion
      defaultExpanded={false}
      expanded={expanded === "panel4"}
      onChange={handleChangePanel("panel4")}
      className="AccordionContainer"
    >
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className="AccordionSummaryContainer"
      >
        <AccordionSummaryTitle
          title="Diagnóstico da ELA"
          icon={<IconNote style={{ width: "24px" }} />}
          progressForm={progressForm}
        />
      </AccordionSummary>
      <AccordionDetails>
        <form autoComplete="off" onSubmit={onSubmit}>
          <Stack className="templateGridForm">
            <Stack>
              <FieldSelect
                label="O diagnóstico é ELA?"
                value={data.diagnosticoEhELA}
                setValue={(value) =>
                  setData((prevState) => ({
                    ...prevState,
                    diagnosticoEhELA: value,
                    dataDiagnosticoELA: "",
                    classificacaoKingsCollege: "",
                    escalaFuncional: "",
                    velocidadeDeProgressao: "",
                    causaELA: "",
                    localDeInicio: "",
                    fenotipoDeInicio: "",
                    observacaoELA: "",
                    sugestaoDiagnostico: "",
                  }))
                }
                items={diagnosticoEhELAOptions.map((c) => {
                  return { id: c.value, label: c.key };
                })}
                required
              />
            </Stack>

            {data.diagnosticoEhELA === "51" ? (
              <Stack sx={{ gridColumn: "span 3" }}>
                <FieldAutocomplete
                  label="Diagnóstico alternativo"
                  options={CIDList}
                  getOptionLabel={(option) =>
                    `${option.co_categoria} - ${option.no_categoria}` || ""
                  }
                  value={
                    CIDList
                      ? CIDList.find(
                          (option) =>
                            option.co_categoria === data.sugestaoDiagnostico
                        )
                      : null
                  }
                  setValue={(e, newValue) => {
                    handleSetData(newValue.co_categoria, "sugestaoDiagnostico");
                  }}
                />
              </Stack>
            ) : (
              <>
                <Stack></Stack>
                <Stack></Stack>
                <Stack></Stack>
              </>
            )}
          </Stack>

          {(data.diagnosticoEhELA === "50" ||
            data.diagnosticoEhELA === "119") && (
            <>
              <Stack className="templateGridForm">
                <FieldDatePicker
                  label="Data de início"
                  value={data.dataDiagnosticoELA}
                  maxDate={dayjs(new Date())}
                  setValue={(value) =>
                    handleSetData(
                      formatDateISO8601(value),
                      "dataDiagnosticoELA"
                    )
                  }
                  required={data.diagnosticoEhELA === "50"}
                  openTo="year"
                  labelDatePicker={"dd/mm/yyyy"}
                />

                <FieldSelect
                  label="Classificação King´s College"
                  value={data.classificacaoKingsCollege}
                  setValue={(value) =>
                    handleSetData(value, "classificacaoKingsCollege")
                  }
                  items={classificacaoKingsCollegeOptions.map((c) => {
                    return { id: c.value, label: c.key };
                  })}
                  required={data.diagnosticoEhELA === "50"}
                />

                <Stack>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    <>
                      <a
                        href={`/consulta/registrar-escala/${idConsultaEvolucao}`}
                        target="blank"
                        className="labelText"
                      >
                        Escala funcional ALSFRS-R
                      </a>
                      {data.diagnosticoEhELA === "50" && (
                        <IconDiamond fill="#FC8518" />
                      )}
                    </>
                    {atualizarEscalaFuncional && (
                      <IconButton
                        onClick={() => {
                          handleSetData(escalaFuncional, "escalaFuncional");
                        }}
                      >
                        <Replay />
                      </IconButton>
                    )}
                  </Grid>
                  <FieldInputText
                    label=""
                    type="number"
                    value={data.escalaFuncional}
                    setValue={(value) =>
                      handleSetData(value, "escalaFuncional")
                    }
                  />
                </Stack>

                <FieldInputText
                  label="Velocidade de progressão"
                  type="number"
                  value={data.velocidadeDeProgressao}
                  setValue={(value) =>
                    handleSetData(value, "velocidadeDeProgressao")
                  }
                  disabled
                  required={data.diagnosticoEhELA === "50"}
                />

                <FieldSelect
                  label="Causa"
                  value={data.causaELA}
                  setValue={(value) => handleSetData(value, "causaELA")}
                  items={causaOptions.map((c) => {
                    return { id: c.value, label: c.key };
                  })}
                  required={data.diagnosticoEhELA === "50"}
                />
                <FieldSelect
                  label="Local de início"
                  value={data.localDeInicio}
                  setValue={(value) => handleSetData(value, "localDeInicio")}
                  items={localDeInicioOptions.map((c) => {
                    return { id: c.value, label: c.key };
                  })}
                  required={data.diagnosticoEhELA === "50"}
                />
                <FieldSelect
                  label="Fenótipo de início"
                  value={data.fenotipoDeInicio}
                  setValue={(value) => handleSetData(value, "fenotipoDeInicio")}
                  items={fenotipoDeInicioOptions.map((c) => {
                    return { id: c.value, label: c.key };
                  })}
                  required={data.diagnosticoEhELA === "50"}
                />
              </Stack>
            </>
          )}

          {data.diagnosticoEhELA !== "" && (
            <>
              <Stack sx={{ mb: 2, color: "#1E729F" }}>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  className="labelText"
                  mb="8px"
                >
                  Observação
                </Grid>
                <textarea
                  value={data.observacaoELA}
                  onChange={(e) =>
                    handleSetData(e.target.value, "observacaoELA")
                  }
                  style={{
                    height: "5rem",
                    border: "1px solid #1E729F",
                    borderRadius: 5,
                    padding: 10,
                    resize: "vertical",
                  }}
                  variant="outlined"
                />
              </Stack>
              <Stack
                direction="row"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 3,
                }}
              >
                <Button variant="outlined" className="buttonText cancel">
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  name="diagnosticoELA"
                  className="buttonText submit"
                >
                  Salvar
                </Button>
              </Stack>
            </>
          )}
        </form>
      </AccordionDetails>
    </Accordion>
  );
}
